module.exports = __webpack_public_path__ + "static/mustafa-karaman-830880f92e4d4fa73a651f6a98517c02.png";